var m = require('./mathTimo');
var f = require('./fileTimo');
var fs = require('fs');
function storeConfiguration(conf) {
    history = 3
    maxNumberOfDigits = 5
    if (conf) {
        history = conf.readingsCount || history
        maxNumberOfDigits = conf.numberOfDigits || maxNumberOfDigits
    }
}

function reset(configuration) {
    storeConfiguration(configuration)
    readings1 = []
    readings2 = []
    readingsCombined = []
    offsets = []
    firstDecimals = []
    readingsInBuffer = 0
    for (var i = 0; i < history; i++) {
        readings1.push([])
        readings2.push([])
        readingsCombined.push([])
        offsets.push([])
        firstDecimals.push([])
        for (var j = 0; j < maxNumberOfDigits; j++) {
            readings1[i].push(-1)
            readings2[i].push(-1)
            readingsCombined[i].push(-1)
            offsets[i].push(-1)
            firstDecimals[i].push(0)
        }
    }
    diffNumbers = []
    for (var i = 0; i < history + 1; i++) {
        diffNumbers.push([])
        for (var j = 0; j < maxNumberOfDigits; j++) {
            diffNumbers[i].push(-100)
        }
    }
    precisions = []
    for (var i = 0; i < maxNumberOfDigits; i++)precisions[i] = -1

}
var precisions = null
var history = null
var maxNumberOfDigits = null
var readings1 = null
var readings2 = null
var readingsCombined = null
var diffNumbers = null
var offsets = null
var firstDecimals = null
var readingsInBuffer = 0

function bufferFull() {
    if (readingsInBuffer < history) return false;
    return true;
}
function pushReadings1() {
    for (var i = readings1.length - 1; i > 0; i--) { readings1[i] = readings1[i - 1] }
}
function pushReadings2() {
    for (var i = readings2.length - 1; i > 0; i--) { readings2[i] = readings2[i - 1] }
}
function pushOffsets() {
    for (var i = offsets.length - 1; i > 0; i--) { offsets[i] = offsets[i - 1] }
}
function pushDiffNumbers() {
    for (var i = diffNumbers.length - 1; i > 0; i--) { diffNumbers[i] = diffNumbers[i - 1] }
}
function pushFirstDecimals() {
    for (var i = firstDecimals.length - 1; i > 0; i--) { firstDecimals[i] = firstDecimals[i - 1] }
}
function addDigits1(result) {
    readingsInBuffer++
    readings1[0] = []
    precisions = []
    for (var i = 0; i < result.digits.length; i++) {
        if (result.digits[i].result >= 0) readings1[0].push(result.digits[i].result)
        else readings1[0].push(-1)
        precisions.push(result.digits[i].precision)
    }
    return readings1[0]
}
function addOffsets(result) {
    offsets[0] = []
    for (var i = 0; i < result.digits.length; i++) {
        if (result.digits[i].offset || result.digits[i].offset===0) {
            offsets[0].push(result.digits[i].offset)
        } else {
            offsets[0].push(-1)
        }
    }
    return offsets[0]
}
function addFirstDecimals(result) {
    firstDecimals[0] = []
    for (var i = 0; i < result.digits.length; i++) {
        firstDecimals[0].push(result.digits[i].firstDecimal * 0.01)
    }
    return firstDecimals[0]
}
function addDigits2(result) {
    readings2[0] = []
    for (var i = 0; i < result.digits.length; i++) {
        if (result.digits[i].result >= 0 && (!result.digits[i].diffNumber)) readings2[0].push(result.digits[i].result)
        else readings2[0].push(-1)

    }
    return readings2[0]
}

function storeDigits1(result) {
    pushReadings1()
    addDigits1(result)
}
function storeDigits2(result) {
    pushReadings2()
    addDigits2(result)
}
function storeOffsets(result) {
    pushOffsets()
    addOffsets(result)
}
function storeFirstDecimals(result) {
    pushFirstDecimals()
    addFirstDecimals(result)
}
function validatedResult(defaultResult) {
    if (!bufferFull()){
        var result={}
        result.digits=[]
        for(var i=0;i<defaultResult.digits.length;i++){
            result.digits[i]={}
            result.digits[i].result=-1
            result.digits[i].offset=-1
            result.digits[i].precision=defaultResult.digits[i].precision
        }
     return result;
    }
    var validatedResult = {}
    validatedResult.digits = []
    validatedResult.reading = 0
    validatedResult.digitCount = 0
    var multiplier = 1
    var digitCount = 0
    var validatedResultIndex = ((history / 2) | 0)
    for (var i = readingsCombined[0].length - 1; i >= 0; i--) {
        validatedResult.digits[i] = {}
        var resultDigit = readingsCombined[validatedResultIndex][i]
        validatedResult.digits[i].result = resultDigit
        validatedResult.digits[i].offset=offsets[validatedResultIndex][i]
        if (resultDigit >= 0) {
            validatedResult.reading += multiplier * resultDigit
            validatedResult.digitCount = digitCount
            multiplier = multiplier * 10
        } else multiplier = 0
        if (multiplier > 0) digitCount++
        validatedResult.digits[i].precision = precisions[i]
    }
    return validatedResult
}
function notNextAndNotSame(previous, current) {
    if (previous < 0 || current < 0) return false;
    if (current == previous) return false;
    if (current - previous) current += 10
    if (current - previous == 1) return false;
    return true;
}
function eliminateChangedDigitsWhenValidOffsets() {
    for (var i = history - 2; i > 0; i--) {
        for (var j = readings1[0].length - 1; j >= 0; j--) {
            if (offsets[i][j] > -1 && notNextAndNotSame(readings1[i + 1][j], readings1[i][j])) {
                if (offsets[i - 1][j] > -1 && notNextAndNotSame(readings1[i][j]), readings1[i - 1][j]) {
                    if (readings1[i - 1][j] >= 0) readings1[i][j] = readings1[i - 1][j]
                    else if (readings1[i + 1][j] >= 0) readings1[i][j] = readings1[i + 1][j]
                    else readings1[i][j] = -1
                }
            }
        }
    }
    for (var i = history - 2; i > 0; i--) {
        for (var j = readings2[0].length - 1; j >= 0; j--) {
            if (offsets[i][j] > -1 && notNextAndNotSame(readings2[i + 1][j], readings2[i][j])) {
                if (offsets[i - 1][j] > -1 && notNextAndNotSame(readings2[i][j]), readings2[i - 1][j]) {
                    if (readings2[i - 1][j] >= 0) {
                        readings2[i][j] = readings2[i - 1][j]
                    }
                    else if (readings2[i + 1][j] >= 0) {
                        readings2[i][j] = readings2[i + 1][j]
                    }
                    else {
                        readings2[i][j] = -1
                    }
                }
            }
        }
    }

}
function alignConsecutiveSingleDigitChanges() {
    for (var i = history - 2; i >= 0; i--) {
        for (var j = readings1[0].length - 1; j >= 0; j--) {
            if (precisions[j] > 1) {
                if (notNextAndNotSame(readings1[i + 1][j], readings1[i][j])) {
                    readings1[i][j] = -1
                }
            }
        }
    }
    for (var i = history - 2; i >= 0; i--) {
        for (var j = readings2[0].length - 1; j >= 0; j--) {
            if (precisions[j] > 1) {
                if (notNextAndNotSame(readings2[i + 1][j], readings2[i][j])) {
                    readings2[i][j] = -1
                }
            }
        }
    }
}
function mostFrequent(list) {
    var mostFrequentCount = 0
    var mostFrequentValue = -1
    var l = list.length
    for (var i = 0; i < l; i++) {
        var count = 0
        for (var j = 0; j < l; j++) {
            if (list[i] == list[j]) count++
        }
        if (count > mostFrequentCount && list[i] >= 0) mostFrequentValue = list[i]
    }
    return mostFrequentValue
}
function combineReadings() {
    for (var i = history - 1; i >= 0; i--) {
        if (i == 0 || i == history - 1) {
            for (var j = readings2[0].length - 1; j >= 0; j--) {
                if (precisions[j] == 1) {
                    if (readings1[i][j] >= 0 && readings2[i][j] >= 0 && readings1[i][j] == readings2[i][j]) {
                        readingsCombined[i][j] = readings1[i][j]
                    } else {
                        readingsCombined[i][j] = -1
                    }
                } else {
                    if (readings1[i][j] >= 0 && readings2[i][j] < 0) readingsCombined[i][j] = readings1[i][j]
                    else if (readings1[i][j] < 0 && readings2[i][j] >= 0) readingsCombined[i][j] = readings2[i][j]
                    else if (readings1[i][j] != readings2[i][j]) {
                        readingsCombined[i][j] = readings2[i][j]
                    } else {
                        readingsCombined[i][j] = readings2[i][j]
                    }
                }
            }

        } else {
            for (var j = readings2[0].length - 1; j >= 0; j--) {
                if (precisions[j] == 1) {
                    if (readings1[i][j] >= 0 && readings2[i][j] >= 0 && readings1[i][j] == readings2[i][j]) {
                        readingsCombined[i][j] = readings1[i][j]
                    } else {
                        readingsCombined[i][j] = -1
                    }
                } else {
                    if (readings1[i][j] >= 0 && readings2[i][j] < 0) readingsCombined[i][j] = readings1[i][j]
                    else if (readings1[i][j] < 0 && readings2[i][j] >= 0) readingsCombined[i][j] = readings2[i][j]
                    else if (readings1[i][j] != readings2[i][j]) {
                        readingsCombined[i][j] = mostFrequent([readings1[i + 1][j], readings2[i + 1][j],readings1[i][j], readings2[i][j], readings1[i - 1][j], readings2[i - 1][j]])
                    } else {
                        readingsCombined[i][j] = readings2[i][j]
                    }
                }
            }
        }
    }
}


function generateDiffNumbers() {
    for (var i = history - 2; i >= 0; i--) {
        for (var j = readings2[0].length - 1; j >= 0; j--) {
            if (diffNumbers[i + 1][j] > -100 && offsets[i + 0][j] >= 0) {
                if (readings2[i + 0][j] >= 0) {
                    diffNumbers[i + 0][j] = readings2[i + 0][j] + firstDecimals[i + 0][j]
                } else {
                    diffNumbers[i + 0][j] = diffNumbers[i + 1][j] + offsets[i + 0][j]
                    if (diffNumbers[i][j] >= 9.50) diffNumbers[i][j] = -100
                }
            } else {
                if (readings2[i + 0][j] >= 0) {
                    diffNumbers[i + 0][j] = readings2[i + 0][j] + firstDecimals[i + 0][j]
                } else {
                    diffNumbers[i + 0][j] = -100
                }
            }
        }
    }
}

function combineReadingsAndDiffNumbers() {
    for (var i = history - 1; i >= 0; i--) {
        for (var j = readings2[0].length - 1; j >= 0; j--) {
            if (j == readings2[0].length - 2 && i == 0) {
            }
            if (readingsCombined[i][j] < 0) {
                if (diffNumbers[i][j] > -100) {
                    readingsCombined[i][j] = Math.round(diffNumbers[i][j])
                }
            }
        }
    }
}

function remove0To9NegativeSteps() {
    for (var i = history - 2; i >= 0; i--) {
        for (var j = readings2[0].length - 1; j > 0; j--) {
            if (readingsCombined[i][j] == 0) {
                if (readingsCombined[i + 1][j] == 9) {
                    if (readingsCombined[i][j - 1] - readingsCombined[i + 1][j - 1] == 0 && readingsCombined[i][j - 1] != -1) {
                        readingsCombined[i][j - 1] = readingsCombined[i + 1][j - 1] + 1
                        if (readingsCombined[i][j - 1] >= 10) readingsCombined[i][j - 1] = 0
                    } else {
                        ;
                    }
                }
            }
        }
    }
}
function removeNegativeSteps() {
    for (var i = history - 2; i >= 0; i--) {
        var previousValue = 0
        var value = 0
        var multiplier = 1
        j = readings2[0].length - 1
        while (j >= 0 && readingsCombined[i + 1][j] >= 0 && readingsCombined[i][j] >= 0) {
            previousValue += readingsCombined[i + 1][j] * multiplier
            value += readingsCombined[i][j] * multiplier
            multiplier = multiplier * 10
            j--
        }
        j++
        if (multiplier >= 100 && readingsCombined[i + 1][j] != 9 && readingsCombined[i][j] != 0) {
            if (previousValue > value) {
                for (var k = 0; k < readings2[0].length; k++) {
                    readingsCombined[i][k] = -1
                }
            }
        }
    }
}
function validatedReading(result1, result2) {
    if (history == null) reset()
    pushDiffNumbers()
    storeDigits1(result1)
    if (result2) {
        storeDigits2(result2)
        storeOffsets(result2)
        storeFirstDecimals(result2)

    }

    eliminateChangedDigitsWhenValidOffsets()
    alignConsecutiveSingleDigitChanges()
    combineReadings()
    generateDiffNumbers()
    combineReadingsAndDiffNumbers()
    remove0To9NegativeSteps()
    removeNegativeSteps()
    var result = validatedResult(result2)
    return result
}

module.exports = {
    reset: function (configuration) { return reset(configuration) },
    validatedReading: function (result1, result2) { return validatedReading(result1, result2) }
}


//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/digitreader2/readingValidation.js
// module id = 831
// module chunks = 0